<script>
    import {API,http_headers,acListCheck, getLoggedUser} from '../global.js'
    import Venta from './venta.svelte'
    import VentaPagos from './venta-pagos.svelte'
    import {USER} from '../store.js'
    import FormasPago from '../cliente/formas-pago.svelte'
    import Swal from 'sweetalert2'
    import {onMount} from 'svelte'

    export let data = {}

    let idcliente = (data.info && data.info.IdCliente) ? data.info.IdCliente : 0
    let page = 0
    let rpp=3
    let eof = false
    let editar = false
    let venta = {}
    let actualizar = false
    let loading = false
    let formaPagoOn = false
    let cobranza = {}

    let ejecutivos = []
    let isAdmin = acListCheck('VENTAS-USERS')
    let ejecutivo = isAdmin?'':getLoggedUser()
    let tipo = ''
    let estado = ''

    let monedas_arr = { "$":1, "U$s":2, "U$r":3}
    
    const pp = itm => itm.planpagos ? JSON.parse(itm.planpagos) : { importeVenta: 0, moneda:"$", idmoneda:0}

    $: refresh = async()=>{
		let res = await fetch(`${API}/ventas/${idcliente}?e=${ejecutivo}&p=${page}&rpp=${rpp}&actualizar=${actualizar}&st=${estado}&tip=${tipo}`)
		const ds = await res.json()
        eof=ds.eof
		return ds || []
	}

    function insert(){
        venta.form = {
            id:0,
            idcliente:idcliente,
            nombre:data.info.RazonSocial || '',
            //nrointercambio : data.info.NroIntercambio || 'S/AFILIAC.',
            usuario:$USER.username,
            tipo:'',
            producto:'Sin Definir',
            fichasocio:data.contactos||{},
            planpagos:{},
            debeaprobar:'',
            fecha:'',
            estado:'TRAMITE',
            observ:'',
            fechaliq:'',
            idtrx:'',
            comisiones:{},
        }
        let domi = data.domicilios ? data.domicilios[0] || {} : {}
        venta.domisocio = {
            Domicilio: domi.Domicilio1 ,
            Localidad: domi.Localidad ,
            Provincia: domi.Provincia ,
            CodPostal: domi.CPLocalidad ,
            Pais: domi.Zona ,

        }
        editar = true
    }

    function update(itm){
        itm.comisiones = JSON.parse(itm.comisiones)
        itm.fichasocio = JSON.parse(itm.fichasocio)
        itm.planpagos = JSON.parse(itm.planpagos)
        delete itm.RowNum
        venta = { form : itm }
        editar=true
    }

    async function chgestado(id,st){
        if(confirm("Cambiar estado a : "+st)){
            let rs = await fetch(`${API}/cliente-chgestado-venta/${id}/${st}`,{
                method:'PUT',
                headers: http_headers
            })

            let ds = await rs.json()
            actualizar = !actualizar
        }
    }


    let data_socio_link = {}

    async function get_link(id,cliente){
        let host = window.location.origin
        loading = true
        let rs = await fetch(`${API}/cliente-get-token/${cliente}`)
        let ds = await rs.json()
        if(ds.success){
            data_socio_link = ds.data
            let texto = `
${data_socio_link.email}



Estimado socio :

    Ingresa a traves del siguiente enlace, para realizar el pago de su transaccion.

    ${host}?m=link-venta&c=${data_socio_link.usuario}&h=${data_socio_link.token}&pid=${id}

`
            navigator.clipboard.writeText(texto);
            Swal.fire({
                  icon: 'success',
                  title: 'Datos copiados al portapapeles.',
                  showConfirmButton: false,
                  timer: 1000
                })
            }

        loading = false

    }


    function close(){
        venta = {  }
        editar=false
    }

    function pagar(){
        return
    }

    function setCobranza(cb){
        cobranza = cb
        //console.log(cb)
        formaPagoOn = true
    }

    function pagePrev(){

        page = page>0 ? page-1 : 0
    }

    function pageNext(){
        page = !eof ? page+1 : page
    }

    onMount( async() => {
        loading = true
        let rs = await fetch(`${API}/usuarios?rpp=9999&activo=1`)
        let ds = await rs.json()
        ejecutivos = ds.data
        //console.log(ejecutivos)
        loading = false

    })
</script>

<div class="container-fluid">

    {#if !editar}

        <!-- controles -->
        <div class="row p-2 rounded" style="background-color:#cDcDcD;">
            <!-- paginador -->
            <div class="col-2">
                <div class="btn-group" role="group" aria-label="Paginacion">
                    <button type="button" class="btn btn-primary" on:click={pagePrev}>&lt;</button>
                    <button type="button" class="btn btn-outline-primary ">{page}</button>
                    <button type="button" class="btn btn-primary" on:click={pageNext}>&gt;</button>
                    <button type="button" class="btn btn-dark" on:click={()=>actualizar = !actualizar}>&orarr;</button>
                </div>
            </div>

            <!-- tipos -->
            <div class="col-3">
                <select class="form-select" aria-label="Tipos" bind:value={tipo}>
                    <option value="" selected>Tipo</option>
                    <option value="VEN">VEN</option>
                    <option value="ALQ">ALQ</option>
                    <option value="TRVL">TRVL</option>
                    <option value="OTR">OTR</option>
                </select>
            </div>

            <!-- estados -->
            <div class="col-3">
                <select class="form-select" aria-label="Estado" bind:value={estado}>
                    <option value="" selected>Estado</option>
                    <option value="TRAMITE">TRAMITE</option>
                    <option value="CANCELADA">CANCELADA</option>
                    <option value="PENDIENTE">PENDIENTE</option>
                    <option value="PE_APROB">PE_APROB</option>
                    <option value="RECH">RECH</option>
                    <option value="OK">OK</option>
                    <option value="FINALIZADA">FINALIZADA</option>
                </select>
            </div>

            <!-- ejecutivos -->
            <div class="col-3">
                <select class="form-select" aria-label="Ejecutivos" bind:value={ejecutivo} disabled={!isAdmin}>
                    <option value='' selected>todos</option>
                    {#each ejecutivos as ej, index}
                        <option value={ej.username}>{ej.username}</option>
                    {/each}
                </select>
            </div>
            <div class="col-1 text-end pe-0">
                <button class="btn btn-danger float-end" on:click={insert} disabled={idcliente===0}>+</button>
            </div>
        </div>
        <!-- headers-->
        <div class="row border-bottom mt-4">
            <div class="col fw-bold ps-2">Usuario</div>
            <div class="col fw-bold ps-2">Cliente</div>
            <div class="col fw-bold ps-2">Tipo</div>
            <div class="col fw-bold ps-2">Fecha</div>
            <div class="col fw-bold ps-2">Estado</div>
            <div class="col fw-bold ps-2">Autoriza</div>
            <div class="col fw-bold ps-2">Importe</div>
            <div class="col fw-bold ps-2">&nbsp;</div>
        </div>
        {#await refresh()}
            <p>Loading....</p>
        {:then items}
            {#each items.data as item}
                <div class="row border-bottom">
                    <div class="col">{item.usuario}</div>
                    <div class="col">{item.idcliente}</div>
                    <div class="col">{item.tipo}</div>
                    <div class="col">{item.fecha.substr(0,10)}</div>
                    <div class="col">{item.estado}</div>
                    <div class="col">{item.debeaprobar}</div>
                    <!-- <div class="col">{(JSON.parse(item.planpagos)).moneda} {(JSON.parse(item.planpagos)).importeVenta.toFixed(2)}</div> -->
                    <div class="col text-end">
                        <span class="btn btn-sm btn-primary my-1" on:click={()=>update(item)}>Ver</span>
                        {#if acListCheck('VENTAS-OK') && item.estado==='PENDIENTE' }
                            <span class="btn btn-sm btn-secondary my-1"  on:click={()=>chgestado(item.id,'OK')}>OK</span>
                            <span class="btn btn-sm btn-secondary my-1" on:click={()=>chgestado(item.id,'RECH')}>RE</span>
                        {/if}
                        {#if (acListCheck('VENTAS-APROBAR') && item.estado==='PE_APROB' && item.debeaprobar===getLoggedUser() ) || ((item.estado==='TRAMITE') && item.usuario===getLoggedUser() )}
                            <span class="btn btn-sm btn-secondary my-1" on:click={()=>chgestado(item.id,'PENDIENTE')}>PE</span>
                            <span class="btn btn-sm btn-danger my-1" on:click={()=>chgestado(item.id,'CANCELADA')}>CANC</span>
                        {/if}
                        {#if item.estado==='OK'}
                            <span class="btn btn-sm my-1 btn-outline-success" on:click={()=>get_link(item.id,item.idcliente)}>Link</span>
                            <span class="btn btn-sm my-1 btn-outline-danger" on:click={()=>setCobranza({
                                                                                            idcliente : item.idcliente,
                                                                                            importe: pp(item).importeVenta.toFixed(2),
                                                                                            idmoneda: monedas_arr[pp(item).moneda||0],
                                                                                            simbolo: pp(item).moneda,
                                                                                            //importe : (JSON.parse(item.planpagos)).importeVenta.toFixed(2),
                                                                                            //idmoneda:1,
                                                                                            //simbolo:(JSON.parse(item.planpagos)).moneda,
                                                                                            tipocli:'',
                                                                                            sociedad:'0',
                                                                                            idcomplejo:'0',
                                                                                            complejo: 'V-'+item.tipo+' '+ item.producto ,
                                                                                            cobranza: 'V-'+item.tipo,
                                                                                            idwventa:item.id
                                                                                        })}>$</span>
                        {/if}
                        {#if item.estado==='OK' && item.usuario===getLoggedUser() }
                            <span class="btn btn-sm btn-success my-1" on:click={()=>chgestado(item.id,'FINALIZADA')}>FIN</span>
                        {/if}
                    </div>

                    <VentaPagos venta={item.id} />

                </div>
            {:else}
                <p>Sin datos para mostrar.</p>
            {/each}
        {:catch error}
            <p>No se pudo realizar la consulta.</p>
        {/await}

    {:else}

        <Venta bind:data={venta} on:close={close}>

        </Venta>

    {/if}

</div>


{#if formaPagoOn}
    <div class="overlay">
        <!--button class="btn btn-danger float-end m-2" id on:click={()=>formaPagoOn=false} ><b>&Cross;</b></button-->
        <FormasPago {cobranza} on:close={()=>formaPagoOn=false}/>
    </div>
{/if}
